import React, { useLayoutEffect, useState } from 'react';
import { useTranslation, Trans } from "react-i18next";
import { useViewport } from 'components/general/useViewPort'
import { useSelector, useDispatch } from 'react-redux'
import { addLegend, removeAllLegends } from 'state-management/actions'
import { getGlobalProps } from 'state-management/selectors'
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';






function getBreakPoints(data, competition, discipline, breakPoint) {
    //CTO-DEPORTE-SIZE
    //CTO--SIZE
    //DEPORTE-SIZE
    //SIZE= xs,sm,md,lg,xl,xxl,default

    const mediaQueries = ["xs", "sm", "md", "lg", "xl", "xxl", "default"];
    const index = mediaQueries.indexOf(breakPoint);
    const mediaQueriesFilter = mediaQueries.slice(index, 7);
    let compose = mediaQueriesFilter.map(media => data + "." + media)
    let composeDiscipline = mediaQueriesFilter.map(media => data + "." + discipline + "." + media)
    let composeCompetition = mediaQueriesFilter.map(media => data + "." + competition + "." + media)
    let composeCompetitionDiscipline = mediaQueriesFilter.map(media => data + "." + competition + "." + discipline + "." + media)
    let out = [...composeCompetitionDiscipline, ...composeCompetition, ...composeDiscipline, ...compose]
    return (out)

}
export default function Label({ data, values, isAddLegend }) {
    const { mirs_competition, mirs_discipline } = useUrlFriendlyToParameters();
    const { t } = useTranslation(['labels']);
    const dispatch = useDispatch();
    const { breakPoint } = useViewport();
    const breaksPointsList = getBreakPoints(data, mirs_competition, mirs_discipline, breakPoint)
    //const val = t(breaksPointsList)

    if (data) {
        return (t(breaksPointsList, values));
    } else {
        return null
    }
}






// LEGENDS TO DELIVER____________________

export const RemoveLegends = ({ related }) => {
    const dispatch = useDispatch();
    {
        console.log("delete:" + related)
    }
    useLayoutEffect(() => {
        dispatch(removeAllLegends)
    }, [related]);

}


export const DrawLegends = ({ related, update }) => {

    console.log("Draw Array")

    const [cloneLegends, SetCloneLegends] = useState();
    const dispatch = useDispatch();

    const customEqual = (oldValue, newValue) => oldValue === newValue
    const globalProps = useSelector(getGlobalProps, customEqual)


    useLayoutEffect(() => {


        dispatch(addLegend({ id: 'test', name: related }))
        console.log("draw: " + related)
        console.log("draw: " + JSON.stringify({ ...globalProps.legends }))
        SetCloneLegends({ ...globalProps.legends })


    }, [update]);

    // const products = useSelector(globalProps => globalProps.legends)
    // return <div>{JSON.stringify({ ...products })}</div>
    return (
        <>
            {JSON.stringify(cloneLegends)}

            {console.log(related)}

            <h3>legends</h3>
            <ul>
                {globalProps.legends && globalProps.legends.data.map((item, index) => (
                    <li key={index}> {item.id}-{item.name}</li>
                ))}
            </ul>
        </>

    );
}


export const AddLegendTest = ({ related }) => {
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        dispatch(addLegend({ id: 'test', name: related }))
    }, [related]);
}

export const DrawLegends1 = ({ related }) => {

    console.log("Draw Array")
    const globalProps = useSelector(getGlobalProps)
    const legends = globalProps.legends
    const [draw, setDraw] = useState();


    useLayoutEffect(() => {
        console.log("draw: " + related)
        console.log("draw: " + JSON.stringify(legends))
        setDraw([...legends.data]);
    }, [related]);


    return (
        draw && <>



            <h3>legends</h3>
            <div>{JSON.stringify(draw)}</div>


            <ul>
                {draw?.map((item, index) => (
                    <li key={index}> {item.id}-{item.name}</li>
                ))}
            </ul>

        </>

    );

}

// END LEGENDS____________________
